type ImporterToastVerb = "Processing" | "Creating";

interface Props {
    subject?: string;
    verb?: ImporterToastVerb;
}

export const ImporterToast: React.FC<Props> = ({
    subject = "transactions",
    verb = "Processing",
}) => (
    <div>
        {verb} your {subject} may take a few minutes. You can leave this page
        and return later.
    </div>
);
